// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nickname[data-v-349855d7]{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.flex[data-v-349855d7]{flex-wrap:wrap}.flex[data-v-349855d7],.truncated[data-v-349855d7]{display:flex;gap:6px}.truncated[data-v-349855d7]{min-width:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
